import DOMPurify from 'dompurify'

/**
 * Sanitize untrusted email HTML before it reaches `dangerouslySetInnerHTML`.
 *
 * MailDesk email bodies originate from external senders, so they must never
 * be rendered raw. This wraps DOMPurify with a tight allowlist of the tags
 * and attributes an email body legitimately needs, strips scripts / styles /
 * iframes outright, and forces every link to open safely in a new tab.
 */

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'a',
  'blockquote',
  'ul',
  'ol',
  'li',
  'pre',
  'code',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'img',
  'span',
  'div',
  'hr',
]

const ALLOWED_ATTR = [
  'href',
  'title',
  'target',
  'rel',
  'src',
  'alt',
  'width',
  'height',
]

export function sanitizeEmailHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ['script', 'style', 'iframe'],
    // Force anchors to open in a new tab without leaking the opener.
    ADD_ATTR: ['target', 'rel'],
  })
}
